module.exports = __webpack_public_path__ + "img/17.08bebe1c.png";